module.exports = "<span class=\"error-form-text text-legend\"\r\n      *ngIf=\"errorMessage !== null\">\r\n\r\n    {{ errorMessage }}\r\n</span>\r\n"